import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewEncapsulation } from "@angular/core";
import { WithConfig } from "ng-zorro-antd/core/config";
import { InputBoolean, InputNumber } from "ng-zorro-antd/core/util";
import { NzPaginationComponent } from "ng-zorro-antd/pagination";
import { PaginationItemRenderContext } from "./pagination.models";

@Component({
  selector: "ui-pagination",
  exportAs: "uiPagination",
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "pagination.component.html",
})
export class UiPaginationComponent extends NzPaginationComponent {
  @Input("uiShowTotal") public nzShowTotal: TemplateRef<{ $implicit: number; range: [number, number] }> | null = null;
  @Input("uiItemRender") public nzItemRender: TemplateRef<PaginationItemRenderContext> | null = null;
  @Input("uiSize") @WithConfig() public nzSize: "default" | "small" = "default";
  @Input("uiPageSizeOptions") @WithConfig() public nzPageSizeOptions: number[] = [10, 20, 30, 40];
  @Input("uiShowSizeChanger") @WithConfig() @InputBoolean() public nzShowSizeChanger = false;
  @Input("uiShowQuickJumper") @WithConfig() @InputBoolean() public nzShowQuickJumper = false;
  @Input("uiSimple") @WithConfig() @InputBoolean() public nzSimple = false;
  @Input("uiDisabled") @InputBoolean() public nzDisabled = false;
  @Input("uiResponsive") @InputBoolean() public nzResponsive = false;
  @Input("uiHideOnSinglePage") @InputBoolean() public nzHideOnSinglePage = false;
  @Input("uiTotal") @InputNumber() public nzTotal = 0;
  @Input("uiPageIndex") @InputNumber() public nzPageIndex = 1;
  @Input("uiPageSize") @InputNumber() public nzPageSize = 10;
  // Design wants no tooltips in the custom reflection paginator implementation
  // This is a workaround to disable it as NgZorro doesn't have an API to control that.
  @Input("uiShowTooltip") @InputBoolean() public showTooltip = true;

  @Output("uiPageSizeChange") public readonly nzPageSizeChange: EventEmitter<number> = new EventEmitter();
  @Output("uiPageIndexChange") public readonly nzPageIndexChange: EventEmitter<number> = new EventEmitter();
}
